<template>
  <div class="common-form">
    <div class="form-header">
      <div class="form-header__title detail_header" v-if="type == 'detail'">
        <div style="flex: 1">
          {{ detail.reserveDate }} {{ language == 'CN' ? detail.mealHourName : detail.mealHourNameEn }}
          {{ detail.mealHourStartTime }} ~ {{ detail.mealHourEndTime }}
        </div>
        <div class="form-header__title-status" v-if="type === 'detail'">
          {{ { 1: $t('statusStr1'), 2: $t('statusStr2'), 6: $t('statusStr3'), 3: $t('statusStr4'), 4: $t('statusStr5'), 5: $t('statusStr6') }[detail.reserveStatus] }}
        </div>
      </div>
    </div>
    <div class="form-header" v-if="type != 'detail'">
      <div class="form-header__title">
        <div class="form-header__title-icon" v-if="status === 'result'">
          <img src="../../../../assets/select-2.png" alt="" />
        </div>
        <div class="form-header__title-text">
          {{
            type === "submit"
              ? $t("reserveStatus3")
              : status === "result"
              ? $t("reserveStatus4")
              : $t("reserveStatus5")
          }}
        </div>
      </div>
      <div class="form-header__info" v-if="type === 'submit'">
        <div class="form-header__info-title">
          {{ $t("paySuccessReserveTime") }}
        </div>
        <div class="form-header__info-text">
          {{ dayDate }} {{ reserveMeal.configName }}
          {{ reserveMeal.startTime }} ～ {{ reserveMeal.endTime }}
        </div>
      </div>
    </div>
    <div class="form-order form-header" v-if="type == 'detail'">
      <img
        :src="(detail.privateroomInfo || {}).imgurl"
        v-if="type === 'detail'"
        class="order-pic"
      />
      <div class="form-order-info">
        <div class="form-order-info-header">
          <div class="form-order-info-title">
            {{ language == 'CN' ? (detail.name || (detail.privateroomInfo || {}).name) : (detail.enName || (detail.privateroomInfo || {}).enName) }}
          </div>
          <div class="form-order-info-tags">
            <span>{{ language == 'CN' ? detail.privateroomGroupName : detail.privateroomGroupNameEn }}</span>
          </div>
        </div>
        <div class="form-order-info-main">
          {{
            $t("accommodatePeople", [
              detail.capacity || (detail.privateroomInfo || {}).capacity,
            ])
          }}
        </div>
      </div>
    </div>
    <div class="form-order" v-else>
      <img
        :src="detail.imgurl ? detail.imgurl : '../../../../assets/card-bg.png'"
        v-if="type === 'submit'"
        @click="onPreview(detail.imgurl)"
        class="order-pic"
      />
      <div class="form-order-info">
        <div class="form-order-info-header">
          <div class="form-order-info-title">
            {{ language == 'CN' ? (detail.name || (detail.privateroomInfo || {}).name) : (detail.enName || (detail.privateroomInfo || {}).enName) }}
          </div>
          <div class="form-order-info-tags">
            <span>{{ language == 'CN' ? detail.privateroomGroupName : detail.privateroomGroupNameEn }}</span>
          </div>
        </div>
        <div class="form-order-info-main">
          {{
            $t("accommodatePeople", [
              detail.capacity || (detail.privateroomInfo || {}).capacity,
            ])
          }}
        </div>
      </div>
    </div>
    <div class="form-main" v-if="type != 'detail'">
      <van-form
        @submit="onSubmit"
        :readonly="status === 'result' || type === 'detail'"
      >
        <van-field
          v-model="formData.reserveName"
          name="reserveName"
          :required="status !== 'result' && type === 'submit'"
          :label="$t('reserveNameLabel')"
          :placeholder="$t('reserveNamePlaceholder')"
          :readonly="status === 'result' || type === 'detail' || updateFlag"
          input-align="right"
        />
        <van-field
          v-model="formData.reservePhone"
          type="tel"
          :required="status !== 'result' && type === 'submit'"
          :name="$t('reservePhoneLabel')"
          :label="$t('reservePhoneLabel')"
          :readonly="status === 'result' || type === 'detail' || updateFlag"
          :placeholder="$t('reservePhonePlaceholder')"
          input-align="right"
        />
        <van-field
          v-model.number="formData.reserveNum"
          type="digit"
          :required="status !== 'result' && type === 'submit'"
          :readonly="status === 'result' || type === 'detail'"
          :name="$t('reserveNumLabel')"
          :label="$t('reserveNumLabel')"
          :placeholder="$t('reserveNumPlaceholder')"
          input-align="right"
        />
        <van-field
          v-model="formData.planReachtime"
          readonly
          type="text"
          :required="status !== 'result' && type === 'submit'"
          :name="$t('reserveTimeLabel')"
          :label="$t('reserveTimeLabel')"
          :placeholder="$t('reserveTimePlaceholder')"
          @click="handleOpenSelectTime"
          input-align="right"
        />

        <!-- <van-field
          v-model="formData.extraInfo"
          type="textarea"
          :name="$t('reserveExtraLabel')"
          :label="$t('reserveExtraLabel')"
          :placeholder="
            status === 'result' || type === 'detail' ? '' : $t('reserveExtraPlaceholder')
          "
          :readonly="status === 'result' || type === 'detail'"
          :border="true"
          rows="2"
          :maxlength="500"
          input-align="right"
        /> -->
        <van-field
          v-model="formData.remark"
          type="textarea"
          :name="$t('remark')"
          :label="$t('remark')"
          :readonly="status === 'result' || type === 'detail'"
          :placeholder="
            status === 'result' || type === 'detail'
              ? ''
              : $t('remarkPlaceholder')
          "
          maxlength="100"
          rows="2"
          autosize
          show-word-limit
          input-align="right"
        />

        <div
          class="form-main-buttons"
          v-if="type === 'submit' && status !== 'result'"
        >
          <van-button @click="$router.back()" native-type="button">{{
            $t("orderCancel")
          }}</van-button>
          <van-button type="info" native-type="submit">{{
            $t("reserveBtn2")
          }}</van-button>
        </div>

        <div
          class="form-main-buttons"
          v-if="type === 'submit' && status === 'result'"
        >
          <van-button @click="$router.back()" native-type="button">{{
            $t("reserveBtn3")
          }}</van-button>
          <van-button
            type="info"
            native-type="button"
            @click="$router.replace('/location/reserve/order/list')"
            >{{ $t("reserveBtn4") }}</van-button
          >
        </div>
      </van-form>
    </div>

    <div v-else class="form-main form-header form-info-reserve">
      <div class="reserve-title">{{ $t("packageFormTitle") }}</div>
      <van-form
        @submit="onSubmit"
        :readonly="status === 'result' || type === 'detail'"
      >
        <van-field
          v-model="formData.reserveName"
          name="reserveName"
          :required="status !== 'result' && type === 'submit'"
          :label="$t('workshopNameLabel')"
          :placeholder="$t('reserveNamePlaceholder')"
          :readonly="status === 'result' || type === 'detail'"
          input-align="right"
        />
        <van-field
          v-model="formData.reservePhone"
          type="tel"
          :required="status !== 'result' && type === 'submit'"
          :name="$t('reservePhoneLabel')"
          :label="$t('reservePhoneLabel')"
          :readonly="status === 'result' || type === 'detail'"
          :placeholder="$t('reservePhonePlaceholder')"
          input-align="right"
        />
        <van-field
          v-model.number="formData.reserveNum"
          type="digit"
          :required="status !== 'result' && type === 'submit'"
          :readonly="status === 'result' || type === 'detail'"
          :name="$t('reserveNumLabel')"
          :label="$t('reserveNumLabel2')"
          :placeholder="$t('reserveNumPlaceholder')"
          input-align="right"
        />
        <van-field
          v-model="formData.planReachtime"
          readonly
          type="text"
          :required="status !== 'result' && type === 'submit'"
          :name="$t('reserveTimeLabel')"
          :label="$t('reserveTimeLabel2')"
          :placeholder="$t('reserveTimePlaceholder')"
          @click="handleOpenSelectTime"
          input-align="right"
        />

        <!-- <van-field
          v-model="formData.extraInfo"
          type="textarea"
          :name="$t('reserveExtraLabel')"
          :label="$t('reserveExtraLabel')"
          :placeholder="
            status === 'result' || type === 'detail' ? '' : $t('reserveExtraPlaceholder')
          "
          :readonly="status === 'result' || type === 'detail'"
          :border="true"
          rows="2"
          :maxlength="500"
          input-align="right"
        /> -->
        <van-field
          v-model="formData.remark"
          type="textarea"
          :name="$t('remark')"
          :label="$t('remark')"
          :readonly="status === 'result' || type === 'detail'"
          :placeholder="
            status === 'result' || type === 'detail'
              ? ''
              : $t('remarkPlaceholder')
          "
          maxlength="100"
          rows="2"
          autosize
          show-word-limit
          input-align="right"
        />

        <div
          class="form-main-buttons"
          v-if="type === 'submit' && status !== 'result'"
        >
          <van-button @click="$router.back()" native-type="button">{{
            $t("orderCancel")
          }}</van-button>
          <van-button type="info" native-type="submit">{{
            $t("reserveBtn2")
          }}</van-button>
        </div>

        <div
          class="form-main-buttons"
          v-if="type === 'submit' && status === 'result'"
        >
          <van-button @click="$router.back()" native-type="button">{{
            $t("reserveBtn3")
          }}</van-button>
          <van-button
            type="info"
            native-type="button"
            @click="$router.replace('/location/reserve/order/list')"
            >{{ $t("reserveBtn4") }}</van-button
          >
        </div>
      </van-form>
    </div>
    <div class="form-header form-info-reserve" v-if="type === 'detail'">
      <div class="reserve-title" style="padding-left: 0">
        {{ $t("orderInfoTitle") }}
      </div>
      <div class="form-header__info">
        <div class="form-header__info-title info-title">
          <span>{{ $t("orderNo") }}：</span>
          <span>{{ detail.orderno }}</span>
        </div>
        <div class="form-header__info-text info-title">
          <span>{{ $t("orderTimeDate") }}：</span>
          <span>{{ detail.createTimeFormat }}</span>
        </div>
      </div>
      <!-- <div class="form-header__info info-title">
        <div class="form-header__info-title">
          {{ $t("paySuccessReserveTime") }}
        </div>
        <div class="form-header__info-text">
          {{ detail.reserveDate }} {{ detail.mealHourName }}
          {{ detail.planReachtime }}
        </div>
      </div> -->
    </div>

    <div class="form-header form-info-reserve" v-if="type === 'detail'">
      <div class="form-header__info">
        <div
          class="form-header__info-title info-title"
          v-if="detail.reserveStatus == 2"
        >
          <span>{{ $t("cancelTime") }}：</span>
          <span>{{ detail.updateTime }}</span>
        </div>
        <div
          class="form-header__info-title info-title"
          v-if="detail.reserveStatus == 2"
        >
          <span>{{ $t("cancelReason") }}：</span>
          <span>{{
            {
              1: $t("cancelReason1"),
              2: $t("cancelReason2"),
              3: $t("cancelReason3"),
              4: $t("cancelReason4"),
            }[detail.cancelType] || "-"
          }}</span>
        </div>
        <div
          class="form-header__info-text info-title"
          v-if="detail.reserveStatus == 6"
        >
          <span>{{ $t("useTime") }}：</span>
          <span>{{ detail.updateTime }}</span>
        </div>
      </div>
    </div>

    <div
      class="form-header bottom-form-btn"
      v-if="type === 'detail' && detail.reserveStatus == 1"
    >
      <div class="form-btn" @click="handleCancelReservation">
        {{ $t("dialogTitle1") }}
      </div>
      <div class="form-btn edit-reserve" @click="handleUpdateReservation">
        {{ $t("updateReserve") }}
      </div>
    </div>

    <!-- 时间 -->
    <van-popup v-model="isOpenSelectDate" round position="bottom">
      <van-datetime-picker
        type="time"
        :title="$t('dateTimePickerTitle')"
        :min-hour="timeRange.minHour"
        :max-hour="timeRange.maxHour"
        @confirm="handleConfirmTime"
        @cancel="isOpenSelectDate = false"
        :filter="filterTime"
      />
    </van-popup>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { ImagePreview, Dialog } from "vant";
export default {
  props: {
    type: String,
    status: String,
  },
  data() {
    return {
      detail: {},
      dayDate: "",
      reserveMeal: {},
      reserveGroup: {},
      formData: {
        remark: "",
      },

      userinfo: {},

      shopId: localStorage.getItem("shopId"),

      isOpenSelectDate: false,
      updateFlag: false,
      language: "",
    };
  },
  computed: {
    timeRange() {
      // item.mealText = dayjs(item.startTime).format('HH:mm') + '-' + dayjs(item.endTime).format('HH:mm');
      const reserveMeal = this.reserveMeal;
      console.log(reserveMeal, "reserveMeal");
      const [minHour, minMinute] =
        reserveMeal.startTime?.split(":").map(Number) || [];
      const [maxHour, maxMinute] =
        reserveMeal.endTime?.split(":").map(Number) || [];
      const time = {
        minHour: minHour,
        minMinute: minMinute,
        maxHour: maxHour,
        maxMinute: maxMinute,
      };
      console.log("return", time);
      return time;
    },
  },
  created() {
    this.userinfo = JSON.parse(localStorage.getItem("customerInfoList"))[0];
    this.language = localStorage.getItem("language");
    if (this.type === "detail") {
      this.loadDetail();
      return;
    }
    const query = this.$route.query;
    const reserveId = query.reserveId;
    const mealHourId = query.mealHourId;
    const dayDate = query.dayDate;

    const reserveInfo = JSON.parse(
      sessionStorage.getItem(`reserveInfo_${reserveId}`)
    );
    const reserveMeal = JSON.parse(
      sessionStorage.getItem(`reserveMeal_${mealHourId}`)
    );
    // const reserveGroup = JSON.parse(
    //   sessionStorage.getItem(`reserveGroup_${reserveInfo.groupId}`)
    // );
    this.detail = reserveInfo;
    this.reserveMeal = reserveMeal;
    // this.reserveGroup = reserveGroup;
    this.dayDate = dayDate;

    if (this.type === "submit") {
      this.formData = {
        reserveName: this.language == 'CN' ? this.userinfo.username || "" : this.userinfo.usernameEn || '',
        reservePhone: this.userinfo.phone || "",
        remark: "",
      };
    }
  },
  methods: {
    async loadDetail() {
      // -
      const query = this.$route.query;
      const reserveId = query.id;

      const res = await this.$logina.post("/api/wxapp/privateroomReserve/get", {
        id: reserveId,
      });
      console.log("res", res);
      const resData = res.data;
      this.detail = {
        ...resData.data,
        createTimeFormat: dayjs(resData.data.createTime).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
      this.formData = { ...resData.data, reserveName: this.language == 'CN' ? this.userinfo.username || "" : this.userinfo.usernameEn || '', };
    },
    async onSubmit() {
      // const planReachtime = this.formData.planReachtime;
      // const time = dayjs(planReachtime, 'HH:mm');
      // const startMinute = time.diff(dayjs(this.reserveMeal.startTime, 'HH:mm'), 'minute');
      // const endMinute = time.diff(dayjs(this.reserveMeal.endTime, 'HH:mm'), 'minute');
      // if (startMinute <= 0 || endMinute >= 0) {
      //   this.$toast('预计到店时间必须在预定时间范围内')
      //   return;
      // }
      if (!this.formData.reserveName) {
        return this.$toast(this.$t("reserveNamePlaceholder"));
      }
      if (!this.formData.reservePhone) {
        return this.$toast(this.$t("reservePhonePlaceholder"));
      }
      if (!this.formData.reserveNum) {
        return this.$toast(this.$t("reserveNumPlaceholder"));
      }
      if (!this.formData.planReachtime) {
        return this.$toast(this.$t("reserveTimePlaceholder"));
      }

      const loading = this.$toast.loading({
        message: this.language == 'CN' ? "提交中..." : 'Submiting...',
        forbidClick: true,
        duration: 0,
      });
      console.log(
        this.userinfo.customerId,
        this.formData,
        "this.userinfo.customerId"
      );

      try {
        const url = this.updateFlag
          ? "/api/wxapp/privateroomReserve/updateByCustomer"
          : "/api/wxapp/privateroomReserve/saveByCustomer";
        const res = await this.$logina.post(url, {
          id: this.updateFlag ? this.detail.id : undefined,
          shopId: this.shopId,
          branchId: this.$route.query.branchId,
          roomId: this.detail.id,
          reserveMealhourId: this.reserveMeal.id,
          reserveDate: this.dayDate,
          ...this.formData,
          customerId: this.userinfo.customerId,
        });
        console.log("res", res);
        this.$toast.success(this.$t('reserveStatus4'));
        this.updateFlag = false;
        // 改变状态
        this.status = "result";
        // 滚动到顶部
        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });
      } finally {
        loading.clear();
      }
    },
    handleOpenSelectTime() {
      if (this.type === "detail" || this.status == "result") return;
      this.isOpenSelectDate = true;
    },
    handleConfirmTime(v) {
      console.log("v", v);
      this.formData.planReachtime = v;
      this.isOpenSelectDate = false;
    },
    filterTime(type, options) {
      console.log("type, options", type, options);
      return options;
    },
    onPreview(url) {
      if (!url) return;
      ImagePreview([url]);
    },
    // 取消预定
    async handleCancelReservation() {
      await Dialog.confirm({
        title: this.$t("dialogTitle1"),
        message: this.$t("dialogMessage"),
      });
      await this.$logina.post("/api/wxapp/privateroomReserve/cancelByCustomer", {
        shopId: localStorage.getItem("shopId"),
        customerId: this.userinfo.customerId,
        id: this.$route.query.id,
      });
      this.$toast.success(this.$t("cancelSuccess"));
      this.$router.back();
    },
    // 修改预定
    handleUpdateReservation() {
      this.type = "submit";
      this.dayDate = this.detail.reserveDate;
      this.reserveMeal = {
        configName: this.detail.mealHourName,
        startTime: this.detail.mealHourStartTime,
        endTime: this.detail.mealHourEndTime,
        id: this.detail.reserveMealhourId,
      };
      this.updateFlag = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.common-form {
  font-size: 14px;
  line-height: 1;

  .form-header {
    padding: 0 20px;
    border-bottom: 10px solid #f7f7f7;
    padding-bottom: 10px;

    .form-header__title {
      display: flex;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
      gap: 12px;
      margin-bottom: 10px;

      .form-header__title-icon {
        width: 32px;
        height: 32px;
        background: #3bdd6d;
        border-radius: 50%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .form-header__title-text {
        flex: 1;

        font-size: 18px;
        font-weight: 500;
        color: #000000;
      }

      .form-header__title-status {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
    .detail_header {
      border: none;
      margin-bottom: 0;
    }

    .form-header__info {
      padding: 10px 0;

      .form-header__info-title {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-bottom: 10px;
      }

      .form-header__info-text {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
    .info-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .bottom-form-btn {
    padding-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .form-btn {
      padding: 12px 24px;
      font-size: 14px;
      border-radius: 25px;
      border: 1px solid #eee;
    }
    .edit-reserve {
      color: #fff;
      background: #4187f2;
      border: none;
    }
  }

  .form-order {
    padding: 20px;
    display: flex;
    // align-items: center;
    gap: 12px;

    .order-pic {
      width: 122px;
      height: 85px;
      background: #f6f7fb;
      border-radius: 4px;
    }

    .form-order-info-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;
      margin-top: 12px;

      .form-order-info-title {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
      }

      .form-order-info-tags {
        display: flex;
        align-items: center;
        gap: 5px;

        span {
          background: #f2f2f2;
          border-radius: 1px;
          padding: 4px 12px;

          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }
      }
    }

    .form-order-info-main {
      font-size: 14px;
      font-weight: 400;
      color: #333;
    }
  }

  .form-main {
    padding: 0 20px;
    margin-bottom: 80px;

    .form-main-buttons {
      display: flex;
      align-items: center;
      gap: 20px;
      margin-top: 20px;

      ::v-deep {
        .van-button {
          flex: 1;
          border-radius: 3px;
          line-height: 1;
        }
      }
    }
  }
  .form-info-reserve {
    padding-top: 20px;
    margin: 0;
    .reserve-title {
      font-size: 16px;
      padding-left: 10px;
      color: #000;
      font-weight: 500;
    }
  }
}
</style>
